import lang from "translations";
import { Path } from "paths";
// import InvoicedSvg from "assets/svg/Invoiced";
import DailyCloseSvg from "assets/svg/DailyClose";
import DashboardSvg from "assets/svg/Dashboard";
import { items } from "modules/setting/receipt-setting/receipt-setting-preview/data";

// eslint-disable-next-line no-unused-vars
const navItems = (access, connectedSiigo = false, showMdm = null, isSocashlessVenue = false) => {
  let items = [
    {
      to: Path.SLASH,
      text: lang.home,
      IconComponent: DashboardSvg,
      exact: true,
    },
    {
      to: Path.TRANSACTION,
      text: lang.transactions,
      icon: "transactions",
      // items: [
      // {
      //   to: Path.TRANSACTION,
      //   text: lang.allTransactions,
      // },
      // {
      //   to: Path.REGISTER_REPORT,
      //   text: lang.registerReports,
      // },
      // {
      //   to: Path.END_OF_DAY_REPORT,
      //   text: lang.endOfDayReports,
      // }
      // ],
    },
    {
      to: Path.LOCATION,
      text: lang.locations,
      icon: "vendor2",
    },
    {
      to: Path.END_OF_DAY_REPORT,
      text: lang.dailyClose,
      IconComponent: DailyCloseSvg,
    },
    {
      to: Path.PRODUCT,
      text: lang.inventory,
      icon: "inventory",
      items: [
        {
          to: Path.PRODUCT,
          text: lang.items,
        },
        {
          to: Path.CATEGORY,
          text: lang.categories,
        },
        {
          to: Path.INVENTORY_SUPPLY_ITEM,
          text: lang.stock,
        },
        // {
        //   to: Path.INVENTORY_STOCK_TRANSFERS,
        //   text: lang.stockTransfers,
        // },
        {
          to: Path.INVENTORY_STOCKTAKE,
          text: lang.stocktake,
        },
      ],
    },
    // {
    //   to: Path.PRODUCT,
    //   text: lang.selling,
    //   icon: "shirt",
    //   items: [
    //     {
    //       to: Path.PRODUCT,
    //       text: lang.products,
    //     },
    //     {
    //       to: Path.CATEGORY,
    //       text: lang.productCategories,
    //     },
    //   ],
    // },
    // {
    //   to: Path.SIIGO_INVOICES,
    //   text: lang.eInvoice,
    //   IconComponent: InvoicedSvg,
    //   hide: !connectedSiigo,
    //   items: [
    //     {
    //       to: Path.SIIGO_REFUND_VOUCHER_REPORT,
    //       text: lang.refundVoucher,
    //     },
    //     {
    //       to: Path.SIIGO_VOUCHER_TOPUP_REPORT,
    //       text: lang.topupVoucher,
    //     },
    //     {
    //       to: Path.SIIGO_ADJUSTMENT_VOUCHER_REPORT,
    //       text: lang.adjustmentVoucher,
    //     },
    //   ],
    // },
    {
      to: Path.BOOKING,
      text: lang.frontOfHouse,
      icon: "bookings",
      items: [
        {
          to: Path.BOOKING,
          text: lang.reservations,
          icon: "bookings",
        },
        {
          to: Path.GUESTS,
          text: lang.guests,
        },
        {
          to: Path.GUEST_PROFILE,
          text: lang.guestProfile,
        },
        {
          to: Path.BAN_TAG,
          text: lang.blockedTags,
        },
        {
          to: Path.VOUCHER,
          text: lang.vouchers,
        },
        {
          to: Path.DISCOUNT,
          text: lang.discounts,
        },
        {
          to: Path.STAFF,
          text: lang.staff,
        },
      ],
    },
    // {
    //   to: Path.MULTI_PROPERTY,
    //   text: lang.multiProperty,
    //   icon: "building",
    //   items: [
    //     {
    //       to: Path.MULTI_PROPERTY_BALANCE_MOVEMENT_IN,
    //       text: lang.balanceMovementsIn,
    //     },
    //     {
    //       to: Path.MULTI_PROPERTY_BALANCE_MOVEMENT_OUT,
    //       text: lang.balanceMovementsOut,
    //     },
    //   ],
    // },
    // {
    //   to: Path.STAFF,
    //   text: lang.staff,
    //   icon: "staff",
    //   items: [
    //     {
    //       to: Path.STAFF,
    //       text: lang.staff,
    //     },
    //     // {
    //     //   to: Path.STAFF_PROFILE,
    //     //   text: lang.staffProfile,
    //     // },
    //   ],
    // },
    // {
    //   to: Path.GUEST,
    //   text: lang.guests,
    //   icon: "guest",
    //   items: [
    //     {
    //       to: Path.GUESTS,
    //       text: lang.guests,
    //     },
    //     {
    //       to: Path.GUEST_PROFILE,
    //       text: lang.guestProfile,
    //     },
    //   ],
    // },
    // {
    //   to: Path.VOUCHER,
    //   text: lang.vouchers,
    //   icon: "voucher",
    // },
    // {
    //   to: Path.DISCOUNT,
    //   text: lang.discounts,
    //   icon: "discount",
    // },
    {
      to: Path.REPORT,
      text: lang.reports,
      icon: "document",
      items: [
        // {
        //   to: Path.REPORT_INVENTORY,
        //   text: lang.inventoryReport,
        // },
        {
          to: Path.REPORT_SALES,
          text: lang.sales,
        },
        {
          to: Path.REPORT_CATEGORY,
          text: lang.categories,
        },
        {
          to: Path.REPORT_GUEST_REFUND,
          text: lang.guests,
        },
        {
          to: Path.REPORT_ACCESS_CONTROL,
          text: lang.accessControlSidebar,
        },
        {
          to: Path.REPORT_TIP,
          text: lang.tips,
        },
        {
          to: Path.REPORT_FREE_CREDITS,
          text: lang.freeCredits,
        },
        {
          to: Path.REPORT_VOUCHER,
          text: lang.vouchers,
        },
        {
          to: Path.REPORT_DISCOUNT,
          text: lang.discounts,
        },
        {
          to: Path.REPORT_ADDITIONAL_CHARGE,
          text: lang.additionalCharges,
        },
        // {
        //   to: Path.REPORT_ON_GROUND,
        //   text: lang.onGround,
        // },
        // {
        //   to: Path.REPORT_REFUND_CLAIM,
        //   text: lang.refunds,
        // },
        // {
        //   to: Path.UNSYNC_TRANSACTION,
        //   text: lang.unsyncTransactionReports,
        // },
        {
          to: Path.MONTHLY_SALE_REPORT,
          text: lang.monthlySaleReport,
          hide: !isSocashlessVenue,
        },
        {
          to: Path.REGISTER_REPORT,
          text: lang.shifts,
        },
        {
          to: Path.REPORT_ARRIVAL_TIME,
          text: lang.arrivalTime,
        },
      ],
    },
    {
      to: Path.DEVICE,
      text: lang.devices,
      icon: "devices",
      items: [
        {
          to: Path.DEVICES,
          text: lang.devices,
        },
        // {
        //   to: Path.DEVICE_SYNC_STATUS,
        //   text: lang.deviceSyncStatus,
        // },
        {
          to: Path.PRINTER,
          text: lang.printers,
        },
      ],
    },
    {
      to: Path.MDM,
      text: lang.mdm,
      icon: "devices",
      hide: !showMdm,
      items: [
        {
          to: Path.MDM,
          text: lang.mdm,
        },
        {
          to: Path.DEVICE_GEO_LOCATION,
          text: lang.deviceGeoLocation,
        },
      ],
    },
    {
      to: Path.SETTING,
      text: lang.settings,
      icon: "gear",
      pinToBottom: true,
      // items: [
      //   {
      //     to: Path.SETTING_GENERAL_SETTING,
      //     text: lang.general,
      //   },
      //   {
      //     to: Path.WRISTBAND_KEEPING,
      //     text: lang.wristbandKeeping,
      //   },
      //   {
      //     to: Path.RECEIPT_SETTING,
      //     text: lang.receipts,
      //   },
      //   // {
      //   //   to: Path.INTEGRATION_SETTING,
      //   //   text: lang.integrations,
      //   // },
      //   {
      //     to: Path.QUESTION_SETTING,
      //     text: lang.checkInQuestions,
      //   },
      //   {
      //     to: Path.SETTING_ACCESS,
      //     text: lang.accessControl,
      //   },
      // ],
    },
  ];
  items = filterItems(items);
  if (!access.length) {
    return items;
  }

  const getFilteredItemsByAccess = (menuItems) => {
    return menuItems
      .map((item) => {
        const hasParentAccess = access.includes(item.to);

        if (item.items?.length) {
          const filteredChildren = getFilteredItemsByAccess(item.items);
          const hasChildAccess = filteredChildren.length > 0;

          if (!hasParentAccess && !hasChildAccess) {
            return null;
          }

          return {
            ...item,
            to: hasParentAccess ? item.to : filteredChildren[0].to,
            items: filteredChildren,
          };
        }

        if (!hasParentAccess) {
          return null;
        }

        return item;
      })
      .filter(Boolean);
  };

  return getFilteredItemsByAccess(items);
};

const filterItems = (items) => {
  return items
    .filter((item) => !item.hide) // Filter out items with `hide: true`
    .map((item) => {
      if (item.items?.length) {
        // Recursively filter nested items
        return {
          ...item,
          items: filterItems(item.items),
        };
      }
      return item;
    })
    .filter((item) => !item.items || item.items.length > 0); // Remove items with empty `items` arrays
};

export default navItems;
